import { API } from 'src/api';
import { BoardItem } from 'src/features/kanban/component/Board/types';

export const useTimesheetService = () => {
  async function fetchTimesheetDetails({ id }: { id: string }) {
    try {
      const response = await API.get(`/timer/timesheet?id=${id}`);
      if (response.data.success) {
        return {
          timelogs: response.data.data.timesheets.map((item) => formatTask(item)),
          config: response.data.data.config,
        };
      } else if (!response.data.success) {
        return response.data.message;
      }
    } catch (error) {
      console.error('error', error);
      return null;
    }
  }

  async function fetchGlobalTimesheetDetails() {
    try {
      const response = await API.post(`/timer/timesheet`);
      if (response.data.success) {
        return {
          timesheets: response.data.data.timesheets.map((item) => formatTask(item)),
          config: response.data.data.config.config,
        };
      } else if (!response.data.success) {
        return response.data.message;
      }
    } catch (error) {
      console.error('error', error);
      return null;
    }
  }

  async function deleteTimeLogEntry(id: string) {
    try {
      const response = await API.delete(`/timer/timelog?id=${id}`);
      return response.data;
    } catch (error) {
      console.error('error', error);
      return null;
    }
  }

  async function updateTimeLogEntry({
    logItemId,
    billable,
    duration: { hours, minutes },
    startDate: startDate,
  }: {
    logItemId: string;
    billable: boolean;
    duration: { hours: string; minutes: string };
    startDate: Date;
  }) {
    try {
      const response = await API.put('/timer/timelog', {
        id: logItemId,
        billable: billable,
        duration: { hours, minutes },
        startDate: startDate,
      });
      return response;
    } catch (error) {
      console.log(error);
      return null;
    }
  }

  async function addTimeLogEntry({
    taskId,
    billable,
    duration: { hours, minutes },
    startDate: startDate,
    description,
  }: {
    taskId: string;
    billable: boolean;
    duration: { hours: string; minutes: string };
    startDate: string[];
    description?: string;
  }) {
    try {
      const payload = {
        task: taskId,
        description: description || '',
        billable,
        date: startDate,
        duration: { hours, minutes },
      };
      const response = await API.post('timer/manual', payload);
      return response;
    } catch (error) {
      console.log(error);
      return null;
    }
  }

  async function saveTimesheetConfig(config: any) {
    try {
      const response = await API.post('/timer/timesheet/config', { config });
      return response;
    } catch (error) {
      console.log(error);
      return null;
    }
  }

  return {
    fetchTimesheetDetails,
    fetchGlobalTimesheetDetails,
    deleteTimeLogEntry,
    updateTimeLogEntry,
    addTimeLogEntry,
    saveTimesheetConfig,
  };
};

function formatTask(data): BoardItem & { boardId: string; columnId: string } {
  return {
    ...data,
    boardId: data.board,
    columnId: data.column,
    id: data._id,
    assignDate:
      data.start_date && data.end_date
        ? [data.start_date, data.end_date]
        : data.end_date
        ? [data.end_date]
        : [],
  };
}
